// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"HZ-z","trustedRetailerTooltipWrapper":"IZ-z"};